import { Image } from '../types/Image'
import { SImageData } from '../types/api/Image'

export const imageTransformer = (image: SImageData): Image => {
  return {
    id: image?.data?.id ?? '',
    ...(image?.data?.attributes as any),
  }
}
